export default __webpack_public_path__ + "static/media/logo_secondary.d9c66098.svg";